'use strict';

var React = require('react'),
    StampDraftStore = require('../stores/StampDraftStore'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    { VerticalDragAnchors, DropEffects } = require('react-dnd'),
    { PropTypes } = React;

var EditorSectionMixin = {
  propTypes: {
    uuid: PropTypes.string.isRequired
  },

  getSectionDragSource(previewUrl) {
    return {
      canDrag() {
        return this.hasPreloadedImage(previewUrl);
      },

      beginDrag() {
        return {
          effectsAllowed: [DropEffects.MOVE],
          dragPreview: this.getPreloadedImage(previewUrl),
          dragAnchors: {
            vertical: VerticalDragAnchors.TOP
          },
          item: {
            uuid: this.props.uuid
          }
        };
      }
    };
  },

  getSectionDropTarget() {
    return {
      over(item, e) {
        var sectionNode = this.getDOMNode(),
            sectionRect = sectionNode.getBoundingClientRect(),
            sectionMidY = sectionRect.top + (sectionRect.bottom - sectionRect.top) / 2,
            fromIndex = StampDraftStore.getSectionIndex(item.uuid),
            isTooCloseFromAbove = (e.clientY > sectionMidY) && (this.props.index === fromIndex - 1),
            isTooCloseFromBelow = (e.clientY < sectionMidY) && (this.props.index === fromIndex + 1),
            draggedSectionId = item.uuid,
            overSectionId = this.props.uuid;

        if (!isTooCloseFromBelow && !isTooCloseFromAbove && draggedSectionId !== overSectionId) {
          DraftActionCreators.moveSection(draggedSectionId, overSectionId);
        }
      }
    };
  }
};

module.exports = EditorSectionMixin;


/** WEBPACK FOOTER **
 ** ./mixins/EditorSectionMixin.js
 **/